// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OrgSlugRouteRouteImport } from './routes/$orgSlug/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InviteInvitationIdRouteImport } from './routes/invite.$invitationId'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as OrgSlugWebhooksRouteImport } from './routes/$orgSlug/webhooks'
import { Route as OrgSlugTokensRouteImport } from './routes/$orgSlug/tokens'
import { Route as OrgSlugSettingsRouteImport } from './routes/$orgSlug/settings'
import { Route as OrgSlugRepositoriesRouteImport } from './routes/$orgSlug/repositories'
import { Route as OrgSlugMembersRouteImport } from './routes/$orgSlug/members'
import { Route as OrgSlugWebhooksIdRouteImport } from './routes/$orgSlug/webhooks_.$id'
import { Route as OrgSlugRepositoriesNameRouteImport } from './routes/$orgSlug/repositories_.$name'
import { Route as OrgSlugAdminImpersonateRouteImport } from './routes/$orgSlug/admin.impersonate'

const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const OrgSlugRouteRoute = OrgSlugRouteRouteImport.update({
            id: '/$orgSlug',path: '/$orgSlug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InviteInvitationIdRoute = InviteInvitationIdRouteImport.update({
            id: '/invite/$invitationId',path: '/invite/$invitationId',getParentRoute: () => rootRouteImport
          })
const authSignInRoute = authSignInRouteImport.update({
            id: '/(auth)/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const authResetPasswordRoute = authResetPasswordRouteImport.update({
            id: '/(auth)/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const OrgSlugWebhooksRoute = OrgSlugWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugTokensRoute = OrgSlugTokensRouteImport.update({
            id: '/tokens',path: '/tokens',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugSettingsRoute = OrgSlugSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugRepositoriesRoute = OrgSlugRepositoriesRouteImport.update({
            id: '/repositories',path: '/repositories',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugMembersRoute = OrgSlugMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugWebhooksIdRoute = OrgSlugWebhooksIdRouteImport.update({
            id: '/webhooks_/$id',path: '/webhooks/$id',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugRepositoriesNameRoute = OrgSlugRepositoriesNameRouteImport.update({
            id: '/repositories_/$name',path: '/repositories/$name',getParentRoute: () => OrgSlugRouteRoute
          })
const OrgSlugAdminImpersonateRoute = OrgSlugAdminImpersonateRouteImport.update({
            id: '/admin/impersonate',path: '/admin/impersonate',getParentRoute: () => OrgSlugRouteRoute
          })





const OrgSlugRouteRouteChildren = {
  OrgSlugMembersRoute: OrgSlugMembersRoute,OrgSlugRepositoriesRoute: OrgSlugRepositoriesRoute,OrgSlugSettingsRoute: OrgSlugSettingsRoute,OrgSlugTokensRoute: OrgSlugTokensRoute,OrgSlugWebhooksRoute: OrgSlugWebhooksRoute,OrgSlugAdminImpersonateRoute: OrgSlugAdminImpersonateRoute,OrgSlugRepositoriesNameRoute: OrgSlugRepositoriesNameRoute,OrgSlugWebhooksIdRoute: OrgSlugWebhooksIdRoute
}

const OrgSlugRouteRouteWithChildren = OrgSlugRouteRoute._addFileChildren(OrgSlugRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,OrgSlugRouteRoute: OrgSlugRouteRouteWithChildren,OnboardingRoute: OnboardingRoute,authResetPasswordRoute: authResetPasswordRoute,authSignInRoute: authSignInRoute,InviteInvitationIdRoute: InviteInvitationIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)